import styled from '@emotion/styled'
import { Theme } from '@mui/material/styles'

const getBackgroundColor = (theme: Theme, variant: string): string => {
  switch (variant) {
    case 'info':
      return theme.palette.info?.main
    case 'success':
      return theme.palette.success?.main
    case 'warning':
      return theme.palette.warning?.main
    case 'error':
      return theme.palette.error?.main
    case 'default':
    default:
      return theme.palette.blue?.[800] as string
  }
}

export const StyledBadge = styled('div')<{
  theme: Theme
  variant: string
}>`
  display: inline-block;
  padding: ${({ theme }) => `${theme.spacing(0.5)} ${theme.spacing(2)}`};
  font-size: 10px;
  font-weight: bold;
  color: ${({ theme }) => theme.palette.white.main};
  background-color: ${({ theme, variant }) => getBackgroundColor(theme, variant)};
  border-radius: ${({ theme }) => theme.spacing(3)};
  text-transform: uppercase;
  margin-left: ${({ theme }) => theme.spacing(1)};
`
